import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Table,
  Spinner,
  Input,
  Row,
  Col
} from "reactstrap";

import "../Assets/css/style.css";
import AdminSidebar from "../Partials/adminsidebar";


const QuestionList = () => {

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [domainId, setDomainId] = useState("");

  // const API_URL = "http://localhost/qads_interview/question/list.php";
  const API_URL = "https://interview.qads.co.in/qads_interview/question/list.php";

  const fetchQuestions = async (domain = "") => {

    setLoading(true);

    try {

      const res = await axios.get(API_URL, {
        params: {
          page: 1,
          limit: 10,
          domain_id: domain
        },
        headers: {
          Authorization: "Bearer YOUR_ADMIN_TOKEN"
        }
      });

      if (res.data.status) {
        setQuestions(res.data.data.questions);
      }

    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  const handleDomainChange = (e) => {
    const value = e.target.value;
    setDomainId(value);
    fetchQuestions(value);
  };

  return (

    <div style={{ display: "flex" }}>

      {/* Sidebar */}
      <AdminSidebar />

      {/* Main Content */}
      <div style={{
        marginLeft: "250px",
        width: "100%",
        padding: "20px"
      }}>

        <Container fluid>

          <h2 className="page-title">Questions List</h2>

          {/* DOMAIN FILTER */}
          <Row className="filter-row">
            <Col md="4">
              <Input
                type="select"
                value={domainId}
                onChange={handleDomainChange}
              >
                <option value="">Select Domain</option>
                <option value="1">Content Creation</option>
                <option value="2">Sales</option>
                <option value="3">Accountant</option>
              </Input>
            </Col>
          </Row>

          {loading ? (
            <div className="loading-box">
              <Spinner color="primary" />
            </div>
          ) : (

            <Table bordered hover responsive>

              <thead>
                <tr>
                  <th>ID</th>
                  <th>Domain</th>
                  <th>Question</th>
                  <th>Answer</th>
                  <th>Marks</th>
                </tr>
              </thead>

              <tbody>

                {questions.length === 0 ? (

                  <tr>
                    <td colSpan="5" className="text-center">
                      No questions found
                    </td>
                  </tr>

                ) : (

                  questions.map((q) => (

                    <tr key={q.id}>
                      <td>{q.id}</td>
                      <td>{q.domain_name}</td>
                      <td>{q.question}</td>
                      <td>{q.correct_answer || "-"}</td>
                      <td>{q.max_marks || "-"}</td>
                    </tr>

                  ))

                )}

              </tbody>

            </Table>

          )}

        </Container>

      </div>
    </div>
  );
};

export default QuestionList;